import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MainLoaderService {
  private _message: string | undefined = undefined;
  private _show: boolean = false;

  get show(): boolean {
    return this._show;
  }

  get message(): string | undefined {
    return this._message;
  }

  setShow(show: boolean): void {
    this._show = show;
    if (!show) this._message = undefined;
  }

  setMessage(
    message: string | undefined,
    show: boolean | undefined = undefined
  ): void {
    this._message = message;
    if (show !== undefined) this.setShow(show);
  }
}
